import { lazyImport } from '@/utils/lazyImport';
import { RequireCapability } from './RequireCapability';

const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');
const { DevicesRoutes } = lazyImport(() => import('@/features/devices'), 'DevicesRoutes');

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  {
    path: '/devices/*',
    element: (
      <RequireCapability capability="canManageDevicesPage">
        <DevicesRoutes />
      </RequireCapability>
    ),
    children: [],
  },
];
